import { RecordingData } from "capacitor-voice-recorder";
import { Room } from "./Room";
import { User } from "./User";
import { EmojiType, ReactionType } from "./local/Types";
import { UploadTask } from "firebase/storage";

export type AutoMessage = 'added' | 'removed' | 'joined' | 'left' | 'call-start' | 'memo-created' | 'memo-updated' | 'pagecall-created';
export type UploadStatus = 'ready' | 'start' | 'uploading' | 'done' | 'error' | 'canceled';

/**
 * Message 클래스
 * 
 * @note user 필드 최적화:
 * - 신규 메시지: MessageUser (id, name, photoUrl만 저장)
 * - 기존 메시지: User 전체 (하위 호환성)
 * - Firestore 저장 시 Cloud Function에서 자동 최소화
 */
export class Message {
  static COL = 'messages';
  id: string;
  created: Date = new Date();
  text?: string;
  recording?: RecordingData;
  emoticon?: ReactionType;
  emoji?: EmojiType;
  files: FileAttachment[] = [];
  replyTo?: User;
  parentMessageId: string | null = null;
  replyToMessageId: string | null = null;
  videoUrl: string | null = null;
  videoUrlProcessed: string | null = null;
  senderEmail?: string;
  userIds: string[];
  roomId: string;
  autoMessage?: AutoMessage;
  autoMessageUser?: User;
  inProgress?: boolean;
  comments?: AIComment[] = [];
  replyCount?: number;
  lastReply?: Message | null;
  repliesLoaded?: boolean;
  unreadReplyCount?: number;
  // 🔧 새로운 reactions 구조: emoticon별 userId 배열
  reactions?: {
    [emoticon: string]: string[];  // emoticon -> userId[]
  };
  constructor(room: Room, public user: User) {
    this.userIds = room.userIds;
    this.roomId = room.id;
    this.id = uuid();
  }
}

function uuid(): string {
  //uuidv4
  return 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export type FileGroup = 'image' | 'doc';
export class FileAttachment {
  isCopy?: boolean;

  constructor(public filename: string, public url: string,
    public sizeByte: number, public group: FileGroup, public type: string) {
  }
}

export class SendingMessage {
  message: Message;
  sendFiles: SendFile[] = [];

  constructor(message: Message) {
    this.message = message;
  }
}

export class SendFile {
  id: string = uuid();
  roomId: string;
  file: File;
  uploadTask: UploadTask | null = null;
  progress: number = 0;
  msgId: string = '';
  index: number = 0;
  status: UploadStatus = 'ready';
  constructor(file: File, roomId: string) {
    this.file = file;
    this.roomId = roomId;
  }
}

// Comments constructs a dialog with bots, attached to a message.
export class AIComment {
  created = new Date(); // Overwrite in backend.
  type: 'ai-text-response' = 'ai-text-response' // Can be extended.
  metaInfo?: string;

  constructor(
    public text: string,
    public botMessageId: string | null,
    public name: string,
    public objectId: string, // Soribot.id
    public imageUrl: string | null) {
  }
};
